import $ from 'jquery';
import Api from '../util/Api';
import Popup from '../util/Popup';
import InputService from '../service/InputService';
import CheckboxService from '../service/CheckboxService';
import SelectService from '../service/SelectService';
import OtherContactItem from '../template/OherContactItem';

let sponsorNumberValid = true;
let captchaSolved = false;

const captchaSuccessCallback = () => {
    captchaSolved = true;
};

const captchaExpireCallback = () => {
    captchaSolved = false;
};

window.captchaSuccessCallback = captchaSuccessCallback;
window.captchaExpireCallback = captchaExpireCallback;

const form = $('.register-form--client, .register-form--partner');
if (form.length > 0) {
    // Проверка номера соглашения спонсора
    let sponsorCheckInProgress = false;
    const sponsorNote = $('.register-form__sponsor-note');
    const sponsorNameInput = $('input[name=SPONSOR_NAME]');

    InputService.onChange('register-sponsor', (value) => {
        if (sponsorCheckInProgress) {
            return;
        }

        if (!value) {
            sponsorNote.text('');
            sponsorNumberValid = true;
            sponsorNameInput.val('');
            return;
        }

        if (value.search(/[^0-9]/) !== -1) {
            sponsorNote.text('');
            $('.control--register-sponsor input')[0].setCustomValidity('Digits only');
            sponsorNumberValid = false;
            return;
        } else {
            $('.control--register-sponsor input')[0].setCustomValidity('');
        }

        sponsorNumberValid = false;
        sponsorCheckInProgress = true;
        InputService.disable('register-sponsor');
        sponsorNote.text('Checking...').css('color', '');

        Api.get('/api/artlife-store/sponsor/live/', {sponsor_id: value}).then((response) => {
            if (response.status === 'success') {
                sponsorNote.text(`Your sponsor: ${response.name}`);
                sponsorNumberValid = true;
                sponsorNameInput.val(response.name);
            } else {
                sponsorNote.text('Agreement number not found').css('color', 'red');
                console.log(response.errorMessage);
            }

            sponsorCheckInProgress = false;
            InputService.enable('register-sponsor');
        });
    });

    // Проверка возраста
    InputService.useDatePicker('register-date-of-birth', {
        language: 'en',
        dateFormat: 'dd.mm.yyyy',
    });
    CheckboxService.onChange('register-18-yo', (value) => {
        if (value) {
            InputService.enable('register-date-of-birth');
        } else {
            InputService.disable('register-date-of-birth');
        }
    });

    // Автозаполнение адреса
    let allCities = [];
    let stateNames = {};
    setTimeout(function () {
        Api.get('/api/places/find-city/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                allCities = response.result.map((city) => {
                    return {...city, nameLower: city.name.toLowerCase()}
                });
            }
        });
    }, 1000);
    setTimeout(function () {
        Api.get('/api/places/find-state/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                response.result.forEach((state) => {
                    stateNames[state.id] = state.name;
                });
            }
        });
    }, 1500);

    let isAddressChanging = false;
    let selectedState = null;

    InputService.onChange('register-address-country', function (value) {
        if (value === 'India') {
            form.find('.control--india').removeClass('hidden');
            form.find('.control--other-country').addClass('hidden');
        } else {
            form.find('.control--india').addClass('hidden');
            form.find('.control--other-country').removeClass('hidden');
        }
    });

    SelectService.onChange('register-address-state-id', function (value) {
        if (!value) {
            selectedState = null;
            return;
        }
        if (value === selectedState) {
            return;
        }

        if (selectedState) {
            SelectService.setValue('register-address-city', false);
            SelectService.setOptions('register-address-city', []);
        }

        selectedState = value;
        InputService.setValue('register-address-state', stateNames[selectedState] || '-');
    });

    SelectService.onChange('register-address-city', function (value) {
        if (!value || isAddressChanging) {
            return;
        }
        isAddressChanging = true;

        if (!selectedState) {
            const selectedCity = allCities.find(city => city.id === value);
            SelectService.setValue('register-address-state-id', selectedCity.state_id);
        }

        setTimeout(() => {isAddressChanging = false;}, 200);
    });

    SelectService.onInput('register-address-city', function (value) {
        if (value.length) {
            if (!selectedState) {
                SelectService.setOptions('register-address-city', allCities.filter((city) => {
                    return city.nameLower.indexOf(value.toLowerCase()) === 0;
                }));
            } else {
                SelectService.setOptions('register-address-city', allCities.filter((city) => {
                    return city.state_id === selectedState && city.nameLower.indexOf(value.toLowerCase()) === 0;
                }));
            }
        } else {
            SelectService.setOptions('register-address-city', []);
        }
    });

    // Добавление и удаление других контактных данных
    const contactOptions = SelectService.getOptions('register-other-contacts');
    $('.register-form__add-contact').on('click', () => {
        const contactType = SelectService.getValue('register-other-contacts');
        if (contactType) {
            $('.register-form-other-contacts').append(
                OtherContactItem(contactOptions.find(option => option.id === contactType))
            );
        }
    });
    $('body').on('click', '.register-form__remove-contact', function() {
        $(this).parents('.register-form-other-contacts__item').remove();
    });

    // Проверка пароля
    $('.control--register-password input')[0].setCustomValidity('The minimum length of this field is 6 characters');

    $('.control--register-password input, .control--register-password-repeat input').keyup(function () {
        const inputPassword = $('.control--register-password input');
        const inputPasswordRepeat = $('.control--register-password-repeat input');
        const inputPasswordValue = inputPassword.val();
        const inputPasswordRepeatValue = inputPasswordRepeat.val();

        if (inputPasswordValue.length < 6) {
            inputPassword[0].setCustomValidity('The minimum length of this field is 6 characters');
            inputPasswordRepeat[0].setCustomValidity('');
        } else {
            if (inputPasswordValue !== inputPasswordRepeatValue) {
                inputPassword[0].setCustomValidity('');
                inputPasswordRepeat[0].setCustomValidity('Passwords are not equal');
            } else {
                inputPassword[0].setCustomValidity('');
                inputPasswordRepeat[0].setCustomValidity('');
            }
        }
    });
}

let inProgress = false;

$('body').on('submit', '.register-form--client, .register-form--partner', function (e) {
    e.preventDefault();

    if (inProgress) {
        return;
    }

    if (!sponsorNumberValid) {
        Popup.notify('Please enter correct sponsorship agreement number or leave the field blank.');
        return;
    }

    const dateFormat = /^(\d{2}).(\d{2}).(\d{4})$/;
    const dobString = InputService.getValue('register-date-of-birth') || '';
    const dob = Date.parse(dobString.replace(dateFormat, '$3-$2-$1'));
    if (
        !CheckboxService.getValue('register-18-yo') ||
        dobString.search(dateFormat) === -1 ||
        isNaN(dob) ||
        Date.now() - dob < 1000 * 60 * 60 * 24 * 365 * 18
    ) {
        Popup.notify('You have to be 18+ years old to register.');
        return;
    }

    if (!captchaSolved) {
        Popup.notify('Please go through Google reCAPTCHA');
        return;
    }

    const data = new FormData(this);

    inProgress = true;
    const isPartner = $(this).hasClass('register-form--partner');

    Popup.notify('Please wait, registration is in progress ...');

    Api.post(`/api/user/register/${isPartner ? 'partner' : 'client'}/`, data).then((response) => {
        if (response.status === 'success') {
            window.location.href = '/personal/agreement';
        } else {
            inProgress = false;
            if (response.errorMessage.indexOf('Public: ') === 0) {
                Popup.notify(response.errorMessage.substr(8));
            } else {
                Popup.notify('User registration error, please try later.');
            }
        }
    });
});
